import { useEffect, useRef } from 'react';
import { updateCreditCardInfoProvided } from 'api/account/updateCreditCardInfoProvided';
import { updatePatientConsultState } from 'api/survey/updatePatientConsultState';
import { useConsult } from 'contexts/ConsultContext';
import { useCurrentUser } from 'contexts/CurrentUserContext';
import { FeatureFlags, useFlag } from 'hooks/useFlag';
import { useQueryParams } from 'hooks/useQueryParams';
import { useNavigate, useParams } from 'react-router-dom';

export default function StripeSuccessPageNp() {
  const currentUser = useCurrentUser();
  const consultState = useConsult();
  const params = useParams();
  const navigate = useNavigate();
  const request = useRef(false);
  const showMemberFinancialPolicy = useFlag(
    FeatureFlags.DisplayMemberFinancialPolicy,
  );
  const { getParam } = useQueryParams();
  const memberId = getParam('memberId');

  useEffect(() => {
    request.current = true;
    updateCreditCardInfoProvided(memberId, true)
      .then(() => {
        return updatePatientConsultState({
          id: params['consultId'] ?? '',
          machine: 'payment',
          event: 'complete_payment',
        });
      })
      .then(() => {
        navigate(`/np/members/${memberId}/schedule/first-appointment`, {
          replace: true,
        });
      });
  }, [
    currentUser.state.account,
    navigate,
    params,
    consultState.consult,
    consultState.careCycleStep,
    consultState,
    showMemberFinancialPolicy,
    memberId,
  ]);

  return <></>;
}
